import { getRequest, putRequest, postRequest, patchRequest } from "common/HttpClient/http-utility";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { GROUPS_FACILITIES_PICKER } from "./GroupsConstant";
export const GroupsServices = () => {
  const apiPaths = INFRAMARK_CONSTANTS.groups.services;
  const services = {
    getAllGroups: async () => {
      const response = await getRequest(`${apiPaths.groupsList}`);
      return response;
    },
    editGroup: async ( groupInfo) => {
      const identifier = groupInfo.code ?? groupInfo.customerCode;
      const response = await putRequest(`${apiPaths.editGroup}${identifier}`, groupInfo);
      return response
    },
    patchGroup: async ( groupInfo, code) => {
      const response = await patchRequest(`${apiPaths.patchGroup}${code}`, groupInfo);
      return response
    },
    addNewGroup: async (groupInfo) => {
      const response = await postRequest(apiPaths.createGroup, groupInfo);
      return response
    },

    patchModuleAccess: async (moduleKey, payload, customerCode) => {
      const encoded = encodeURIComponent(moduleKey);
      const response = await patchRequest(
        `${apiPaths.patchGroup}${customerCode}/module-access/${encoded}`,
        payload
      );
      return response;
    },

    patchCustomerDataConnections: async (customerCode, payload) => {
      // WMP-2395: path is the canonical customer code (PATCH /customers/{code}).
      const response = await patchRequest(
        `${apiPaths.patchGroup}${customerCode}`,
        payload
      );
      return response;
    },
    getHachwimsFacilityOptions: async ({
      text,
      page = GROUPS_FACILITIES_PICKER.DEFAULT_PAGE,
      size = GROUPS_FACILITIES_PICKER.PAGE_SIZE,
    } = {}) => {
      const params = { page, size };
      const searchValue = text ? text?.trim() : "";
      if (searchValue) params.name = searchValue;
      const response = await getRequest(apiPaths.hachwimsFacilityOptions, params);
      return response;
    },
  };
  return services;
};
